import { ClientEvent, ClientEventData } from '../helpers/GoFormzAnalytics-types';

export type Survey = {
  [page: number]: SurveyQuestion;
};

export type SurveyQuestion = {
  title: string;
  /** The delay to wait before moving onto the next question */
  delay: number;
  className?: string;
  trackEvent?: string;
  trackAs?: string;
  trackGoFormzEvent?: ClientEvent;
  answers?: SurveyAnswer[];
  last?: boolean;
};

export type SurveyAnswer = {
  answer: string;
  key: ClientEventData;
};

export const survey: Survey = {
  1: {
    className: 'first',
    title: `Welcome to GoFormz, let's get started.`,
    delay: 2500
  },
  2: {
    className: 'second',
    title: 'How do you intend to use GoFormz?',
    trackEvent: 'GoFormz Intent',
    trackAs: 'Intent',
    trackGoFormzEvent: ClientEvent.OnboardingGoFormzIntent,
    delay: 500,
    answers: [
      { answer: 'Business use', key: ClientEventData.OnboardingGoFormzIntent_Business },
      { answer: 'Personal use', key: ClientEventData.OnboardingGoFormzIntent_Personal }
    ]
  },
  3: {
    className: 'third',
    title: 'Primarily, who will be filling out forms?',
    trackEvent: `Who's Filling Out Forms`,
    trackAs: 'Answer',
    trackGoFormzEvent: ClientEvent.OnboardingWhosFillingForms,
    delay: 500,
    answers: [
      { answer: 'Myself', key: ClientEventData.OnboardingWhosFillingForms_Myself },
      { answer: 'My team', key: ClientEventData.OnboardingWhosFillingForms_Team },
      { answer: 'My customers', key: ClientEventData.OnboardingWhosFillingForms_Customers }
    ]
  },
  4: {
    className: 'fourth',
    title: `Awesome, now it's time to build your digital form.`,
    delay: 2500,
    last: true,
    answers: []
  }
};
